import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    newMessageAlert: [{
        chatId: '',
        count: 0
    }],
    contacts: [],
}

const chatSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {
        setNewMessagesAlert: (state, action) => {
            const chatId = action.payload.chatId;
            const index = state.newMessageAlert.findIndex(item => item.chatId === chatId);
            if (index !== -1) {
                state.newMessageAlert[index].count += 1;
            } else {
                state.newMessageAlert.push({
                    chatId,
                    count: 1
                })
            }
        },
        removeNewMessagesAlert: (state, action) => {
            const chatId = action.payload.chatId;
            state.newMessageAlert = state.newMessageAlert.filter(item => item.chatId !== chatId);
        },
        setLatestMessage: (state, action) => {
            state.latestMessage = action.payload;
        },
        setContactsList: (state, action) => {
            state.contacts = action.payload;
        },
        setScheduledMessageCount: (state, action) => {
            state.scheduleMessageCount = action.payload
        }
    }
})

export const { setNewMessagesAlert, removeNewMessagesAlert, setLatestMessage, setContactsList, setScheduledMessageCount } = chatSlice.actions;

export default chatSlice;
